import { useState } from "react"
import PropTypes from "prop-types"

const ApplicationLogo = ({ url, name }) => {
  const [valid, setValid] = useState(true)

  const onError = () => {
    setValid(false)
  }

  return <div className="integration-logo-container">
    {url && valid && <img
      src={`https://assets.ompnt.com/partner-logos/${url}`}
      alt={`${name} logo`}
      className="integration-logo"
      onError={onError}
    />}
  </div>
}

ApplicationLogo.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string.isRequired,
}

export default ApplicationLogo
